import { Zap } from 'lucide-react';

interface GlobalLoaderProps {
    text?: string;
}

export function GlobalLoader({ text = "Ładowanie..." }: GlobalLoaderProps) {
    return (
        <div className="h-screen w-screen flex items-center justify-center bg-background relative overflow-hidden">
            {/* Background pattern matching the app */}
            <div className="bg-grid-pattern" />

            <div className="flex flex-col items-center gap-6 relative z-10 animate-in fade-in duration-500">
                <div className="relative">
                    {/* Pulsing background circle */}
                    <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl animate-pulse" />

                    {/* Logo/Icon */}
                    <div className="w-16 h-16 bg-card border border-border rounded-2xl flex items-center justify-center shadow-2xl relative">
                        <Zap className="w-8 h-8 text-primary animate-pulse" fill="currentColor" />
                    </div>
                </div>

                <div className="flex flex-col items-center gap-2">
                    <h3 className="font-medium text-lg tracking-tight">{text}</h3>
                    <div className="flex gap-1.5">
                        <div className="w-1.5 h-1.5 rounded-full bg-primary/60 animate-bounce [animation-delay:-0.3s]" />
                        <div className="w-1.5 h-1.5 rounded-full bg-primary/60 animate-bounce [animation-delay:-0.15s]" />
                        <div className="w-1.5 h-1.5 rounded-full bg-primary/60 animate-bounce" />
                    </div>
                </div>
            </div>
        </div>
    );
}
